<span
  [class.text-3xl]="size() === 'default'"
  [class.text-2xl]="size() === 'medium'"
  [class.text-lg]="size() === 'small'"
  [class.font-semibold]="size() === 'medium' || size() === 'small'"
  [attr.data-testid]="'section-header-headline'">
  <ng-content></ng-content>
</span>